import { NgOptimizedImage } from '@angular/common';
import { Component, viewChild } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NzAlertComponent } from 'ng-zorro-antd/alert';
import { NzButtonComponent } from 'ng-zorro-antd/button';
import { NzCheckboxComponent } from 'ng-zorro-antd/checkbox';
import { NzWaveModule } from 'ng-zorro-antd/core/wave';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzTypographyModule } from 'ng-zorro-antd/typography';
import { FormsModule } from '@angular/forms';
import { FikoYTKokBilesenComponent } from '../../../../../service/kok-bilesen/kok-bilesen.component';
import { FikoYTKartComponent } from '../../../../../service/fikoyt-ui/src/lib/fikoyt-kart/fikoyt-kart.component';
import { FikoYTDalgaComponent } from '../../../../../service/fikoyt-ui/src/lib/fikoyt-dalga/fikoyt-dalga.component';
import { FikoYTYuvarlakResimComponent } from '../../../../../service/fikoyt-ui/src/lib/fikoyt-yuvarlak-resim/fikoyt-yuvarlak-resim.component';
import { IstekOlayTuru } from '../../../../../service/fikoyt.istek.service';

@Component({
  selector: 'fikoyt-aramiza-katil',
  imports: [FormsModule,
    NgOptimizedImage, RouterLink, FikoYTKartComponent, NzWaveModule, NzAlertComponent, NzInputModule, NzButtonComponent, NzIconModule, NzTypographyModule, NzCheckboxComponent, FikoYTYuvarlakResimComponent],
  templateUrl: './aramiza-katil.component.html',
  standalone: true,
  styleUrl: './aramiza-katil.component.less'
})
export class AramizaKatilComponent extends FikoYTKokBilesenComponent {

  readonly rippleComponent = viewChild.required<FikoYTDalgaComponent>('ripple');

  dosyaProfilResmi: File | null = null;

  form: any = {
    kullaniciAdi: '',
    ePosta: '',
    parola: '',
    parolaTekrar: '',
    isim: '',
    soyIsim: '',
    anlasma: false,
  };

  imageChange($event: File | null) {
    this.dosyaProfilResmi = $event;
  }

  gonder() {
    const formData: FormData = new FormData();

    // formData.append(this.idProfilresmi, this.dosyaProfilResmi)
    // console.log(this.formUye)
    // this.form.profilResmi = this.idProfilresmi
    if (this.dosyaProfilResmi != null) {
      let id: string = this.FikoYT.fikoIdUret();
      formData.append(id, this.dosyaProfilResmi);
      this.form.profilResmi = id;
    }


    formData.append('req_body', JSON.stringify(this.form));

    this.FikoYT.istekler.fapisteV1('POST', 'FikoYT.sistem.uye.ol', { vucutParametreler: formData }).subscribe((snc: any) => {
      if (snc.turu == IstekOlayTuru.Cevaplandi) {
        if (snc.sonuc.body.durum.hata == true) {
          let hataMesajlari = "";
          snc.sonuc.body.durum.hatalar.forEach((hata: any) => {
            hataMesajlari += hata.mesaj + "\n";
          });

          this.nzNotification.error("Hatalar Var", hataMesajlari, {
            nzStyle: {
              "white-space": "pre-line",
            }
          });
        } else {
          this.nzNotification.success("Kayıt Başarılı", "Kaydınız Onaylandıktan Sonra Hesabınız Aktif Edilecektir");
          // this.router.navigate(["/"]);
        }



      };
    });
  }
}
